import { createSlice } from "@reduxjs/toolkit";
import { bookingSliceBody } from "./bookingBody";
/*
Dùng cho chọn product trong pass
 */
const bookingOfChildSlice = createSlice({
  name: "bookingOfChild",
  ...bookingSliceBody,
});

export default bookingOfChildSlice.reducer;
export const bookingOfChildActions = bookingOfChildSlice.actions;
